import React from "react";
import Navbar from "../components/Navbar";
import DevicesTable from "../components/DevicesTable"
import CounterTile from "../components/CounterTile";

const Devices = () => {
  document.body.style = "background-color: #FAFCFE";
  return (
    <>
      <header>
        <Navbar userName={"Jack"} />
      </header>
      <main className="main">
        <div className="device__tile">
          <CounterTile className={"device-tile device-tile--devices"} icon="laptop" value={"5"} about="Devices" />
          <CounterTile className={"device-tile device-tile--online"} icon="signal" value={"4"} about="Online" />
          <CounterTile className={"device-tile device-tile--offline"} icon="signal" value={"1"} about="Offline" />
          <CounterTile className={"device-tile device-tile--faults"} icon="cross" value={"0"} about="Faults" />
        </div>
        <DevicesTable />
      </main>
    </>
  );
};

export default Devices;
